module.exports = __webpack_public_path__ + "img/logo.c51dca29.jpg";